import { createApp } from 'vue'

import App from './App.vue'
// import { GlobalCmComponent } from 'codemirror-editor-vue3'
// import { InstallCodeMirror } from "codemirror-editor-vue3"; 
const app = createApp(App)
// app.use(InstallCodeMirror) // 注册为全局组件
app.mount('#app')